import LegalPage from '../../components/LegalPage';
import CardNB from '../../components/ui-nb/CardNB';

export default function TermsPage() {
  const today = new Date().toLocaleDateString('fr-FR', { year: 'numeric', month: 'long', day: 'numeric' });

  return (
    <LegalPage
      title="Conditions d'Utilisation"
      lastUpdated={`Dernière mise à jour: ${today}`}
    >
      <CardNB>
        <div className="space-y-8">
          <p className="text-lg text-nb-text-secondary">
            En créant un compte ou en utilisant Tellow Up!, vous acceptez ces conditions.
          </p>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Description du Service</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! est une plateforme SaaS pour la gestion des réparations. Nous fournissons des outils pour suivre l'état des réparations, gérer les techniciens et coordonner avec les clients.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Compte Utilisateur</h2>
            <p className="text-nb-text-secondary">
              Vous devez fournir des informations exactes lors de la création du compte. Vous êtes responsable de la confidentialité de vos identifiants. Vous devez avoir au moins 16 ans pour utiliser notre service.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Organisations</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! permet aux utilisateurs de créer ou de rejoindre des organisations (ateliers). Les administrateurs peuvent inviter des employés et gérer les permissions. Les utilisateurs sont responsables de leurs propres actions au sein de l'organisation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Codes de Libération</h2>
            <p className="text-nb-text-secondary">
              Un Code de Libération est un identifiant unique permettant aux clients de suivre l'état de réparation sans créer de compte. Traitez votre code comme confidentiel. Tellow Up! n'est pas responsable du suivi non autorisé si vous partagez votre code.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Utilisation Acceptable</h2>
            <p className="text-nb-text-secondary">
              Vous acceptez de ne pas: (a) utiliser le service à des fins illégales; (b) tenter un accès non autorisé; (c) transmettre du code malveillant; (d) interférer avec les opérations du service; (e) extraire ou récupérer des données sans permission.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Propriété Intellectuelle</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! et son logo sont des marques déposées. Le logiciel et le contenu sont protégés par les lois sur la propriété intellectuelle. Vous conservez la propriété des données que vous soumettez mais vous nous accordez une licence pour les utiliser.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Paiements et Abonnements</h2>
            <p className="text-nb-text-secondary">
              Tellow Up! propose des plans d'abonnement pour la gestion des organisations. Les paiements sont traités de manière sécurisée via Stripe. Vous autorisez Stripe à débiter votre moyen de paiement pour tous les frais. Les abonnements se renouvellent automatiquement sauf annulation. Vous pouvez annuler à tout moment via les paramètres de votre compte.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Remboursements</h2>
            <p className="text-nb-text-secondary">
              Tous les paiements sont traités via Stripe. Les demandes de remboursement sont traitées selon les politiques de Stripe. Contactez billing@tellowup.com pour les problèmes liés aux paiements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Annulation</h2>
            <p className="text-nb-text-secondary">
              Vous pouvez annuler votre abonnement à tout moment. L'annulation prend effet à la fin de la période de facturation en cours. Aucun remboursement pour les périodes partielles.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Limitation de Responsabilité</h2>
            <p className="text-nb-text-secondary">
              TELLOW UP! EST FOURNI "EN L'ÉTAT" SANS GARANTIES. NOUS NE SOMMES PAS RESPONSABLES DES DOMMAGES INDIRECTS, INCIDENTIELS OU CONSÉCUTIFS. NOTRE RESPONSABILITÉ TOTALE NE DÉPASSERA PAS LE MONTANT QUE VOUS NOUS AVEZ PAYÉ AU COURS DES DOUZE DERNIERS MOIS.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Modifications</h2>
            <p className="text-nb-text-secondary">
              Nous pouvons modifier ces conditions à tout moment. Nous vous notifierons par email ou par un avis sur notre site. L'utilisation continue après les modifications constitue l'acceptation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Loi Applicable</h2>
            <p className="text-nb-text-secondary">
              Pour les utilisateurs en France: ces conditions sont régies par le droit français. Pour les utilisateurs au Mexique: ces conditions sont régies par le droit mexicain. Pour les utilisateurs aux États-Unis: ces conditions sont régies par le droit américain applicable.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-black mb-3">Contact</h2>
            <p className="text-nb-text-secondary">
              Pour toute question concernant ces conditions, contactez-nous à:
            </p>
            <p className="mt-2 text-nb-text-secondary">
              <a href="mailto:legal@tellowup.com" className="text-nb-black font-bold underline">legal@tellowup.com</a>
            </p>
          </section>
        </div>
      </CardNB>
    </LegalPage>
  );
}
